export { default as FacilityListTemplate } from './FacilityList'; 
export { default as FacilityEditTemplate } from './FacilityEdit'; 
export { default as FacilityPreviewTemplate } from './FacilityPreview';
export { default as FacilityScheduleTemplate } from './FacilitySchedule';
export { default as FacilityCreateTemplate } from './FacilityCreate';
export { default as FacilityHistoryListTemplate } from './FacilityHistoryListTemplate';
